var map = {
	"./alice.png": "cpKD",
	"./argent.svg": "2cZM",
	"./atomic.png": "eO6O",
	"./authereum.png": "Au9o",
	"./coinomi.jpg": "lvUc",
	"./coolwallet-s.png": "Llh7",
	"./equal.jpg": "bEOK",
	"./gnosis-safe.png": "NhvJ",
	"./gridplus.png": "1o1U",
	"./huobi.jpg": "Mg0P",
	"./imtoken.png": "ZtiA",
	"./infinito-wallet.png": "TA1g",
	"./math-wallet.png": "NQbr",
	"./metamask.png": "smgh",
	"./mykey.png": "OWO+",
	"./pillar-wallet.jpg": "hFPr",
	"./rainbow.png": "Hmsq",
	"./safepal.png": "s6jq",
	"./spatium.jpg": "K+Pc",
	"./tokenary.png": "XKqO",
	"./tokenpocket.png": "9R5E",
	"./trust-wallet.svg": "HSyv",
	"./walleth.png": "w7OZ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8JWg";